import { render } from "./Vehicle.vue?vue&type=template&id=5c77aba3&scoped=true"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"

import "./Vehicle.vue?vue&type=style&index=0&id=5c77aba3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c77aba3"]])

export default __exports__